import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';

import DesktopDropdown from './DesktopDropdown/DesktopDropdown';
import MobileModal from './MobileDropdown/MobileModal';

import media from '../../styles/media.style';
import Placeholder from '../Placeholder';
import { BLACK, WHITE } from '../../styles/variables.style';

const DesktopDropdowns = styled.div`
  display: flex;
  margin-bottom: 50px;
`;

const MobileDropdowns = styled.div``;

const Button = styled.button`
  align-items: center;
  background-color: ${BLACK};
  border: none;
  color: ${WHITE};
  cursor: pointer;
  display: flex;
  font-size: 16px;
  font-weight: 800;
  height: 57px;
  letter-spacing: 1px;
  line-height: 57px;
  outline: none;
  padding: 0 20px;
  position: relative;
  text-align: left;
  text-transform: uppercase;
  width: 100%;

  ${media.tabletL`
    height: 85px;
    line-height: 85px;
    padding: 0 40px;
  `};

  span {
    margin-right: 50px;
    font-weight: 800;
    font-size: 12px;
    letter-spacing: 1px;

    ${media.tabletL`
    font-size: 16px;
  `};
  }

  ::after {
    content: '';
    position: absolute;
    top: 42%;
    right: 20px;
    transform: translateY(-50%) rotate(-45deg);
    width: 6px;
    height: 6px;
    border-top: 2px solid ${WHITE};
    border-right: 2px solid ${WHITE};

    ${media.tabletL`
    right: 40px;
  `};
  }

  ::before {
    content: '';
    position: absolute;
    top: 58%;
    right: 20px;
    transform: translateY(-50%) rotate(135deg);
    width: 6px;
    height: 6px;
    border-top: 2px solid ${WHITE};
    border-right: 2px solid ${WHITE};

    ${media.tabletL`
    right: 40px;
  `};
  }
`;

class DropdownMenu extends React.Component {
  static propTypes = {
    copy: PropTypes.shape().isRequired,
    dropdowns: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    screenSize: PropTypes.number.isRequired,
    onUpdate: PropTypes.func.isRequired,
  };

  state = {
    mobileFilterOpen: false,
  };

  componentDidUpdate = () => {
    const { mobileFilterOpen } = this.state;
    const { screenSize } = this.props;
    if (screenSize > 1 && mobileFilterOpen) this.setState({ mobileFilterOpen: false });
  };

  closeMobileFilters = dropdown => {
    if (dropdown) this.props.onUpdate(dropdown);
    this.setState({ mobileFilterOpen: false });
  };

  openMobileFilters = () => {
    this.setState({ mobileFilterOpen: true });
  };

  handleDropdownUpdate = payload => {
    this.props.onUpdate(
      this.props.dropdowns.map(dropdown => {
        if (payload[dropdown.id]) {
          return { ...dropdown, active: payload[dropdown.id] };
        }
        return dropdown;
      })
    );
  };

  toggleMobileFilters = () => {
    this.setState(({ mobileFilterOpen }) => ({ mobileFilterOpen: !mobileFilterOpen }));
  };

  render = () => {
    const { mobileFilterOpen } = this.state;
    const { copy, dropdowns, screenSize } = this.props;

    if (screenSize > 1) {
      return (
        <DesktopDropdowns>
          {dropdowns.map(dropdown => (
            <DesktopDropdown key={dropdown.id} {...dropdown} onUpdate={this.handleDropdownUpdate} />
          ))}
        </DesktopDropdowns>
      );
    }

    return (
      <MobileDropdowns>
        <Button onClick={this.openMobileFilters}>{copy.filters || <Placeholder w="100px" h="20px" />}</Button>
        <MobileModal close={this.closeMobileFilters} copy={copy} dropdowns={dropdowns} open={mobileFilterOpen} />
      </MobileDropdowns>
    );
  };
}

const mapState = state => ({
  screenSize: state.screenSize,
});

export default connect(mapState)(DropdownMenu);



// WEBPACK FOOTER //
// ./src/components/DropdownMenu/DropdownMenu.js